import { guardNumber } from "../numbers";
import type { Nullable } from "../types";

export function calculateCubicMeters<
	T extends {
		length?: Nullable<number>;
		width?: Nullable<number>;
		height?: Nullable<number>;
	},
>(item: T): number {
	const length = Math.max(0, guardNumber(item.length));
	const width = Math.max(0, guardNumber(item.width));
	const height = Math.max(0, guardNumber(item.height));
	return length * width * height;
}
